import React, { useMemo } from 'react';
import { AiFillCar } from 'react-icons/ai';
import Button from '../../components/shared/buttons/Button';
import Row from '../../components/shared/table/Row';
import SelectableRow from '../../components/shared/table/SelectableRow';
import Table from '../../components/shared/table/Table';

const ClientsTable = ({ clients, loading, onClientClick, onClientVehiclesClick }) => {
  const tableRows = useMemo(
    () =>
      clients.map((client, i) => (
        <SelectableRow key={i} onClick={() => onClientClick(client)}>
          <Row children={client.firstName} />
          <Row children={client.lastName || '-'} />
          <Row children={client.phone} />
          <Row
            children={
              <div title="Автомобілі" className="w-full text-end z-10">
                <Button
                  onClick={(event) => {
                    event.stopPropagation();
                    onClientVehiclesClick(client);
                  }}
                  variant="secondary2"
                  disabled={loading}
                >
                  <AiFillCar size={20} />
                </Button>
              </div>
            }
          />
        </SelectableRow>
      )),
    [onClientVehiclesClick, loading, clients, onClientClick],
  );

  return <Table columns={columns} data={tableRows} onRowClick={() => ({})} />;
};

const columns = [
  { name: "Ім'я", className: 'w-[30%%]' },
  { name: 'Прізвище', className: 'w-[35%]' },
  { name: 'Телефон', className: 'w-[30%]' },
  { name: 'Дії', className: 'w-[5%] text-center' },
];

export default ClientsTable;
